import WorkspaceUrls from '../../workspace.urls';
import { AssetType } from '../../../../../../models/defines';
import { IWSContext } from '../../../../../../models/workspace/workspace-model';

class WorkspaceAssetsUrls {
    public getUploadPhotoFromPhotoLibrary(wsContext: IWSContext) {
        const baseUrl = this.getWorkspaceAssetsUrl(wsContext);
        return baseUrl + '/upload-from-photo-library';
    }

    public getGenerateVideoPOSTUrl(wsContext: IWSContext) {
        const baseUrl = this.getWorkspaceAssetsUrl(wsContext);
        return baseUrl + '/generate/video';
    }
    public getGenerateImagePOSTUrl(wsContext: IWSContext) {
        const baseUrl = this.getWorkspaceAssetsUrl(wsContext);
        return baseUrl + '/generate/image';
    }
    public getRemoveAssetsDELETEUrl(wsContext: IWSContext) {
        const baseUrl = this.getWorkspaceAssetsUrl(wsContext);
        return baseUrl + '/';
    }
    public getUploadAssetPOSTUrl(wsContext: IWSContext) {
        const baseUrl = this.getWorkspaceAssetsUrl(wsContext);
        return baseUrl + '/';
    }
    public getCreateFolderPOSTUrl(wsContext: IWSContext) {
        const baseUrl = this.getWorkspaceAssetsUrl(wsContext);
        return baseUrl + '/folder';
    }
    public getAssetsListGETUrl(wsContext: IWSContext) {
        const baseUrl = this.getWorkspaceAssetsUrl(wsContext);
        return baseUrl + '/';
    }
    public getSpecificAssetByIdsGETUrl(wsContext: IWSContext) {
        const baseUrl = this.getWorkspaceAssetsUrl(wsContext);
        return `${baseUrl}/ids`;
    }
    public getAssetsFilteredByParamGETUrl(wsContext: IWSContext, filterByParam: AssetType) {
        const base = this.getWorkspaceAssetsUrl(wsContext);
        return base + `/filter/${filterByParam}`;
    }

    public getMoveFilePUTUrl(wsContext: IWSContext) {
        const baseUrl = this.getWorkspaceAssetsUrl(wsContext);
        return baseUrl + '/move';
    }
    public getWorkspaceAssetsUrl(wsContext: IWSContext) {
        const bsaeUrl = WorkspaceUrls.getDetailsWSUrl(wsContext);
        return `${bsaeUrl}/assets`;
    }
}

export default new WorkspaceAssetsUrls();
